import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';

import { NutritionCodeEnum } from 'Common/Constants/Enumeration/NutritionCodeEnum';
import * as ServingMenuItemsActions from 'PointOfSale/modules/servingOptions/state/actions';
import * as QueueActions from 'PointOfSale/modules/queue/state/actions';
import * as LookUpActions from 'PointOfSale/modules/lookup/state/actions';
import * as TeacherActions from 'PointOfSale/modules/teacher/state/actions';
import * as IndividualServingActions from 'PointOfSale/modules/individualServing/state/actions';
import * as POSActions from 'PointOfSale/state/actions';
import * as DialogActions from 'Components/dialogs/state/actions';
import SessionMenuComponent from 'PointOfSale/modules/layouts/component/servingOptions/SessionMenu';
import {
  SessionTypes,
  POS_ROUTES,
  QueueStatusEnum,
} from 'PointOfSale/modules/common/constants';
import { createToast, toastType } from 'Common/ToastHelper';
import * as POSSelectors from 'PointOfSale/selectors';
import {
  getHomeButtonDialogType,
  DIALOG_TYPES,
} from 'PointOfSale/helpers/homeButtonHelper';

import 'PointOfSale/styles/components/sessionMenu.less';
import { NOTIFICATION_DIALOG_MESSAGES } from 'Common/Constants';

class SessionMenu extends React.Component {
  state = {
    openSession: false,
    openQSI: false,
    openAutoServe: false,
    openAddSessionModal: false,
  };

  /** called when trying to open the "add session" modal */
  onSessionAdd = async () => {
    const {
      isCurrentSessionMealCounter,
      hasUnprocessedMeals,
      hasBoughtItems,
      hasPaidAmount,
      hasTeacherStudentsSelected,
    } = this.props;

    const dialogType = getHomeButtonDialogType({
      isCurrentSessionMealCounter,
      hasUnprocessedMeals,
      hasBoughtItems,
      hasPaidAmount,
      hasTeacherStudentsSelected,
    });

    try {
      await this.waitForConfirmationIfNeeded(dialogType);
      this.setState({ openAddSessionModal: true });
    } catch (e) {}
  };

  /** called before trying to switch between existing sessions */
  onSessionClick = async ({ key, data }) => {
    const {
      isCurrentSessionMealCounter,
      hasUnprocessedMeals,
      hasBoughtItems,
      hasPaidAmount,
      hasTeacherStudentsSelected,
    } = this.props;

    const dialogType = getHomeButtonDialogType({
      isCurrentSessionMealCounter,
      hasUnprocessedMeals,
      hasBoughtItems,
      hasPaidAmount,
      hasTeacherStudentsSelected,
    });

    try {
      await this.waitForConfirmationIfNeeded(dialogType);
      this.props.POSActions.switchSession({ key, data });
    } catch (e) {}
  };

  /**
   * From a DIALOG_TYPE, determine if a dialog should be shown and show it if so
   * Resolves if the dialog has been overriden, rejects otherwise
   * @param {homeButtonHelper.DIALOG_TYPE} dialogType
   * @param {function} callback
   */
  waitForConfirmationIfNeeded = dialogType => {
    const { DialogActions } = this.props;

    const ret = new Promise((resolve, reject) => {
      switch (dialogType) {
        case DIALOG_TYPES.MEAL_COUNTER:
          DialogActions.setNotificationDialog({
            ...NOTIFICATION_DIALOG_MESSAGES.HOME_CONFIRM_SERVE_MEAL_COUNTER,
            functionsToRunOnOk: [resolve],
            functionsToRunOnCancel: [reject],
          });
          break;
        case DIALOG_TYPES.INCOMPLETE:
          DialogActions.setNotificationDialog({
            ...NOTIFICATION_DIALOG_MESSAGES.HOME_CONFIRM_SERVE_INCOMPLETE_TRANSACTION,
          });
          setTimeout(reject, 0);
          break;
        default:
          setTimeout(resolve, 0);
          break;
      }
    });

    return ret;
  };

  showHideAddSessionModal = showHide => {
    this.setState({ openAddSessionModal: showHide });
  };

  /** called when setting (even if "none") the current quick serve item */
  onQSIClick = item => {
    const {
      ServingMenuItemsActions,
      TeacherActions,
      activeSession,
      isCurrentSessionMealCounter,
    } = this.props;

    if (isCurrentSessionMealCounter) {
      if (item.NutritionCode !== NutritionCodeEnum.FederalType1Meal) {
        createToast(
          toastType.error,
          'Error',
          'Item is not a valid CEP item',
          true
        );
        return;
      }
    }

    ServingMenuItemsActions.setQuickServeItem(item);
    if (activeSession === SessionTypes.Teacher) {
      TeacherActions.resetAllStudentsBoughtItems();
      TeacherActions.resetAllStudentsSelected();
      TeacherActions.resetAllStudentsError();
    }
    this.setState({ openQSI: false });
  };

  /** called when performing any auto serve actions (start, stop, add, sub) */
  onAutoServeClick = (event, data) => {
    event.stopPropagation();
    const {
      IndividualServingActions,
      QueueActions,
      history,
      activeSession,
      ServingMenuItemsActions,
      sessions,
      currentProfile,
      queue,
    } = this.props;

    if (data.value === QueueStatusEnum.ON) {
      const quickServeItem = _.get(sessions, [activeSession, 'quickServeItem']);
      if (!quickServeItem) {
        this.setState({
          openAutoServe: false,
        });

        return createToast(
          toastType.error,
          'Error',
          'Please select a quick serve item to enable autoserve',
          true
        );
      }
    }

    if (data.value !== 'delay') {
      this.setState({
        openAutoServe: false,
      });

      let newQueueStatus = data.value;

      newQueueStatus === QueueStatusEnum.ON
        ? ServingMenuItemsActions.setAutoServeOnOff(true)
        : ServingMenuItemsActions.setAutoServeOnOff(false);

      if (
        this.props.location.pathname !== POS_ROUTES.QUEUE &&
        newQueueStatus === QueueStatusEnum.ON
      ) {
        newQueueStatus = QueueStatusEnum.PAUSED;
        if (queue.length === 0) {
          history.push(POS_ROUTES.QUEUE);
        }
      }

      QueueActions.changeQueueStatus(newQueueStatus);

      if (
        activeSession === SessionTypes.Queue &&
        data.value === QueueStatusEnum.OFF
      ) {
        const id = _.get(currentProfile, 'profile.Id');
        if (id) {
          history.push(`${POS_ROUTES.QUEUE}/${id}`);
          IndividualServingActions.addQuickServeItem();
        } else {
          history.push(POS_ROUTES.QUEUE_NEW);
        }
      }
    }
  };
  menuClick = selectedIndex => {
    const {
      currentProfile,
      queueStatus,
      QueueActions,
      LookUpActions,
    } = this.props;

    if (currentProfile) {
      if (queueStatus === QueueStatusEnum.ON)
        QueueActions.changeQueueStatus(QueueStatusEnum.PAUSED);
    }
    LookUpActions.showLookup(false);
    if (selectedIndex === 1) {
      this.setState({
        openSession: !this.state.openSession,
        openQSI: false,
        openAutoServe: false,
      });
    } else if (selectedIndex === 2) {
      this.setState({
        openSession: false,
        openQSI: !this.state.openQSI,
        openAutoServe: false,
      });
    } else {
      this.setState({
        openSession: false,
        openAutoServe: !this.state.openAutoServe,
        openQSI: false,
      });
    }
  };
  onBlur = selectedIndex => {
    if (selectedIndex === 1) {
      this.setState({
        openSession: false,
      });
    } else if (selectedIndex === 2) {
      this.setState({
        openQSI: false,
      });
    } else {
      this.setState({
        openAutoServe: false,
      });
    }
  };
  increment = () => {
    const { ServingMenuItemsActions, sessions, activeSession } = this.props;
    ServingMenuItemsActions.setActiveSessionInterval(
      sessions[activeSession].timeInterval + 1
    );
  };
  decrement = () => {
    const { ServingMenuItemsActions, sessions, activeSession } = this.props;
    if (sessions[activeSession].timeInterval > 0) {
      ServingMenuItemsActions.setActiveSessionInterval(
        sessions[activeSession].timeInterval - 1
      );
    }
  };

  render() {
    const {
      openSession,
      openAddSessionModal,
      openAutoServe,
      openQSI,
    } = this.state;
    const {
      sessions,
      activeSession,
      quickServeItems,
      queueStatus,
      cepTypeId,
      hasMealCounterSession,
    } = this.props;

    return (
      <SessionMenuComponent
        cepTypeId={cepTypeId}
        openSession={openSession}
        openAddSessionModal={openAddSessionModal}
        openQSI={openQSI}
        openAutoServe={openAutoServe}
        sessionMenuClick={this.menuClick.bind(this, 1)}
        qsiMenuClick={this.menuClick.bind(this, 2)}
        autoServeClick={this.menuClick.bind(this, 3)}
        onSessionBlur={this.onBlur.bind(this, 1)}
        onQSIBlur={this.onBlur.bind(this, 2)}
        onAutoServeBlur={this.onBlur.bind(this, 3)}
        showHideAddSessionModal={this.showHideAddSessionModal}
        quickServeItems={quickServeItems}
        queueStatus={queueStatus}
        sessions={sessions}
        activeSession={activeSession}
        onAutoServeClick={this.onAutoServeClick}
        increment={this.increment}
        decrement={this.decrement}
        onSessionClick={this.onSessionClick}
        onQSIClick={this.onQSIClick}
        onSessionAdd={this.onSessionAdd}
        hasMealCounterSession={hasMealCounterSession}
      />
    );
  }
}

const mapStateToProps = state => ({
  sessions: POSSelectors.getSessions(state),
  activeSession: POSSelectors.getActiveSession(state),
  quickServeItems: POSSelectors.getSelectedFoodItems(state),
  queueStatus: POSSelectors.getQueueStatus(state),
  currentProfile: POSSelectors.getCurrentProfile(state),
  cepTypeId: POSSelectors.getSelectedCepTypeId(state),
  hasMealCounterSession: POSSelectors.hasMealCounterSession(state),
  autoServe: POSSelectors.getAutoServe(state),
  queue: POSSelectors.getQueue(state),
  isCurrentSessionMealCounter: POSSelectors.getIsCurrentSessionMealCounter(
    state
  ),
  hasUnprocessedMeals: POSSelectors.getHasUnprocessedMeals(state),
  hasBoughtItems: POSSelectors.getHasBoughtItems(state),
  hasPaidAmount: POSSelectors.getHasPaidAmount(state),
  hasTeacherStudentsSelected: POSSelectors.getHasTeacherStudentsSelected(state),
});

const mapDispatchToProps = dispatch => ({
  POSActions: bindActionCreators(POSActions, dispatch),
  ServingMenuItemsActions: bindActionCreators(
    ServingMenuItemsActions,
    dispatch
  ),
  QueueActions: bindActionCreators(QueueActions, dispatch),
  LookUpActions: bindActionCreators(LookUpActions, dispatch),
  IndividualServingActions: bindActionCreators(
    IndividualServingActions,
    dispatch
  ),
  TeacherActions: bindActionCreators(TeacherActions, dispatch),
  DialogActions: bindActionCreators(DialogActions, dispatch),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SessionMenu)
);



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/layouts/container/servingOptions/SessionMenu.js